import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-terms-and-conditions',
    templateUrl: './terms-and-conditions.component.html',
    styleUrl: './terms-and-conditions.component.scss',
    host: {
        class: 'app-terms-and-conditions'
    },
    standalone: false
})
export class TermsAndConditionsComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
